var map = {
	"./en-us.json": "e3b5",
	"./es-us.json": "9477",
	"./ja-jp.json": "86da",
	"./pt-br.json": "02a2",
	"./th.json": "8680",
	"./zh-ch.json": "9598",
	"./zh-hk.json": "d9e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";